import {
  loginChallenge,
  loginPassKey,
  registerPassKey,
  registerPassKeyChallenge,
} from "../api/pass-keys";
import { showNotification } from "../helpers/utils";

// Función para convertir Base64 URL-safe a Base64 estándar
function base64urlToBase64(base64Url: string) {
  return base64Url.replace(/-/g, "+").replace(/_/g, "/");
}

export default function useAuth() {
  // const { userInfo } = useCurrentUser();
  const register = async ({ email }: { email: string }) => {
    try {
      const response: any = await registerPassKeyChallenge({
        email,
      });
      const options = response?.data;

      if (options) {
        // Convertir el challenge a Base64 estándar y luego a Uint8Array
        const challengeBase64 = base64urlToBase64(options.challenge);
        options.challenge = Uint8Array.from(window.atob(challengeBase64), (c) =>
          c.charCodeAt(0)
        );

        // Convertir user.id a Base64 estándar y luego a Uint8Array
        const userIdBase64 = base64urlToBase64(options.user.id);
        options.user.id = Uint8Array.from(window.atob(userIdBase64), (c) =>
          c.charCodeAt(0)
        );

        const credential = await navigator.credentials.create({
          publicKey: {
            ...options,
            pubKeyCredParams: [
              { type: "public-key", alg: -7 }, // ES256
              { type: "public-key", alg: -257 }, // RS256
            ],
          },
        });

        if (credential && credential instanceof PublicKeyCredential) {
          await registerPassKey({
            email,
            credential: {
              id: credential.id,
              type: credential.type,
              response: {
                clientDataJSON: btoa(
                  String.fromCharCode(
                    ...new Uint8Array(credential.response.clientDataJSON)
                  )
                ),
              },
            },
          });

          showNotification({
            kind: "success",
            message: "Llave de acceso registrada con éxito",
          });
        } else {
          showNotification({
            kind: "error",
            message: "Error al registrar la llave de acceso",
          });
        }
      }
    } catch (e) {}
  };

  const login = async ({ email }: { email: string }) => {
    try {
      const res: any = await loginChallenge({ email });
      const options = res?.data;

      if (options) {
        // Convertir el challenge a Base64 estándar y luego a Uint8Array
        const challengeBase64 = base64urlToBase64(options.challenge);
        options.challenge = Uint8Array.from(atob(challengeBase64), (c) =>
          c.charCodeAt(0)
        );

        const credential = await navigator.credentials.get({
          publicKey: options,
        });

        if (credential && credential instanceof PublicKeyCredential) {
          const authRes = await loginPassKey({
            email,
            credential: {
              id: credential?.id,
              type: credential.type,
              response: {
                clientDataJSON: btoa(
                  String.fromCharCode(
                    ...new Uint8Array(credential.response.clientDataJSON)
                  )
                ),
              },
            },
          });

          if (authRes?.data?.success) {
            return authRes;
          } else {
            return {
              error: "Error en autenticación",
              success: false,
            };
          }
        } else {
          return {
            success: false,
            error: "Credencial no valida",
          };
        }
      } else {
        return {
          success: false,
          error: "Error al obtener el desafio",
        };
      }
    } catch (e) {}
  };

  const hasPasskey = async () => {
    if (!window.PublicKeyCredential || !navigator.credentials) {
      return false; // El navegador no soporta WebAuthn
    }

    try {
      const credential = await navigator.credentials.get({
        publicKey: {
          challenge: new Uint8Array(32), // Desafío ficticio obligatorio
          allowCredentials: [], // Permite buscar cualquier credencial
          userVerification: "preferred",
        },
      });

      return !!credential; // Devuelve true si hay una credencial almacenada
    } catch (error) {
      console.error("Error al verificar passkey:", error);
      return false;
    }
  };

  return {
    loginWithPassKey: login,
    registerPassKey: register,
    hasPasskey,
  };
}
